import { jsx as r } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import m from "../../../../internal/AnchorButton/AnchorButton.js";
import { ButtonVariant as f } from "../../../../internal/Button/types.js";
import { SupportedLocation as p } from "../../../../internal/CapitalHeader/constants.js";
import c from "../../../../internal/Card/Card.js";
import { TypographyVariant as e } from "../../../../internal/Typography/types.js";
import i from "../../../../internal/Typography/Typography.js";
import { SUMMARY_TEXT_EMAIL as n } from "../CapitalOfferSummary/constants.js";
/* empty css                             */
import { Translation as l } from "../../../../internal/Translation/Translation.js";
import { Fragment as s } from "../../../../../external/preact/dist/preact.module.js";
import { useConfigContext as d } from "../../../../../core/ConfigContext/context.js";
const I = () => {
  var o, t, a;
  return ((a = (t = (o = d()) == null ? void 0 : o.extraConfig) == null ? void 0 : t.legalEntity) == null ? void 0 : a.countryCode) === p.US ? /* @__PURE__ */ r(c, { filled: !0, noOutline: !0, children: [
    /* @__PURE__ */ r(i, { variant: e.CAPTION, className: "adyen-pe-capital-offer-legal-notice--title", children: /* @__PURE__ */ r(l, { translationKey: "capital.offerLegalNoticeTitleUS", fills: { break: /* @__PURE__ */ r("br", {}) } }) }),
    /* @__PURE__ */ r("br", {}),
    /* @__PURE__ */ r(i, { variant: e.CAPTION, className: "adyen-pe-capital-offer-legal-notice--description", children: /* @__PURE__ */ r(
      l,
      {
        translationKey: "capital.offerLegalNoticeDescriptionUS",
        fills: {
          email: /* @__PURE__ */ r(
            m,
            {
              href: `mailto:${n}`,
              variant: f.TERTIARY,
              className: "adyen-pe-capital-offer-summary__info--email",
              children: n
            }
          ),
          break: /* @__PURE__ */ r(s, { children: [
            /* @__PURE__ */ r("br", {}),
            /* @__PURE__ */ r("br", {})
          ] })
        }
      }
    ) })
  ] }) : null;
};
export {
  I as CapitalOfferLegalNotice
};
